/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Chat_FailedInputs */

const en_us2_coaching_chat_failed = /** @type {(inputs: Coaching_Chat_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The message was not sent. Try again.`)
};

const pt_br2_coaching_chat_failed = /** @type {(inputs: Coaching_Chat_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mensagem não foi enviada. Tente de novo.`)
};

const pt_pt2_coaching_chat_failed = /** @type {(inputs: Coaching_Chat_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mensagem não foi enviada. Tente de novo.`)
};

/** @type {(inputs: Coaching_Chat_FailedInputs) => LocalizedString} */
const es_419_coaching_chat_failed = en_us2_coaching_chat_failed;

/** @type {(inputs: Coaching_Chat_FailedInputs) => LocalizedString} */
const fr_fr2_coaching_chat_failed = en_us2_coaching_chat_failed;

/** @type {(inputs: Coaching_Chat_FailedInputs) => LocalizedString} */
const de_de2_coaching_chat_failed = en_us2_coaching_chat_failed;

/** @type {(inputs: Coaching_Chat_FailedInputs) => LocalizedString} */
const it_it2_coaching_chat_failed = en_us2_coaching_chat_failed;

/**
* | output |
* | --- |
* | "The message was not sent. Try again." |
*
* @param {Coaching_Chat_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat_failed = /** @type {((inputs?: Coaching_Chat_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Chat_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat_failed(inputs)
	if (locale === "es-419") return es_419_coaching_chat_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat_failed(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat_failed(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat_failed(inputs)
	return en_us2_coaching_chat_failed(inputs)
});
export { coaching_chat_failed as "coaching.chat_failed" }